import CustomerProfileCalculator from './CustomerProfileCalculator'

export default CustomerProfileCalculator
